import { format } from 'date-fns';
import { MaybeDate } from '../../../../components/common/date-picker/MaybeDate';
import { MaybeTimeOption } from '../../../../components/common/time-select/TimeOption';
import {
	AirportCodesWithParkingBooking,
	airportParkingBookingRoute,
} from '../models/AirportParkingBookingRoute';

export function getParkingRerouteUrl(
	airport: AirportCodesWithParkingBooking,
	startDate: MaybeDate,
	endDate: MaybeDate,
	startTime: MaybeTimeOption,
	endTime: MaybeTimeOption,
) {
	if (!startDate || !startTime || !endDate || !endTime || !airport) {
		throw new Error(`Invalid airport code: ${airport} or form data`);
	}

	const formattedEndDate = format(endDate, 'MM/dd/yyyy');
	const formattedStartDate = format(startDate, 'MM/dd/yyyy');

	return `${
		airportParkingBookingRoute[airport].url
	}?entryDate=${encodeURIComponent(
		formattedStartDate,
	)}&entryTime=${encodeURIComponent(
		startTime.value,
	)}&exitDate=${encodeURIComponent(
		formattedEndDate,
	)}&exitTime=${encodeURIComponent(
		endTime.value,
	)}&parkingDetailsSubmitted=1&progressToNextStep=1&form_id=tpa_pre_book_parking_form&form_build_id=form-tWUySsnb9IV5lIDgVoMaQP3xxD42LLA6C5eibiapIcg&op=View+Rate`;
}
